var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChildComponentType } from './childComponentType';
import { ComponentOptions } from '../componentOptions';
/**
 * Child component options.
 */
var ChildComponentOptions = /** @class */ (function (_super) {
    __extends(ChildComponentOptions, _super);
    function ChildComponentOptions() {
        var _this = _super.call(this) || this;
        _this.type = ChildComponentType.InWindow;
        /**
         * The the interval to wait for the component before triggering an error and the 'disposed' event.
         */
        _this.contentDisposeTimeout = 3000;
        return _this;
    }
    return ChildComponentOptions;
}(ComponentOptions));
export { ChildComponentOptions };
//# sourceMappingURL=childComponentOptions.js.map